import {api} from "../index";

export const LoginApi = (data) => api.post("api/Login/Login", data);
export const LogoutApi = () => api.post("logout");
export const refreshToken = (refreshToken) =>
  api.post("/api/Login/RefreshToken", refreshToken);
export const DemoLoginApi = (data) => api.post("api/DemoAccounts/Create", data);
export const changePassword = (data) => api.post("api/Clients/ChangePassword", data);
export const resetPasswordApi = (data) => api.post("api/Clients/ResetPassword", data);



/**
 * Function to call the CreateDemoAccount API.
 * Sends data as query parameters using a GET method.
 * 
 * @param {Object} data - The data object containing query parameters.
 * @returns {Promise} - The API response.
 */
export const getDemoAccount = (data) => {
  return api.get("api/DemoAccounts/CreateDemoAccount", { params: data });
};
